/**
 * Page of subscription selection.
 *
 * Copyright © Ircam Amplify 2025-2026
 */
import { fetchCompanyConsumption, fetchPrice } from '@/api'
import FullScreenLayout from '@/components/FullScreenLayout'
import { DefaultSelectTier } from '@/components/SelectTier/DefaultSelectTier'
import { TopUpSelectTier } from '@/components/SelectTier/TopUpSelectTier'
import { getUserState, useSelector } from '@/store'
import { TierType } from '@amplify3/duplo-back-end'
import { Box, LinearProgress } from '@mui/material'
import { useEffect } from 'react'

/**
 * A progress bar with the title of the page, centered in the window.
 */
const TitleLinearProgress = () => {
  return (
    <FullScreenLayout
      className="!h-auto min-h-screen bg-white text-black"
      title="Simple, transparent pricing"
    >
      <Box
        sx={{
          flex: 1, // take remaining height below title
          display: 'flex',
          alignItems: 'center', // vertical center
          justifyContent: 'center', // horizontal center
        }}
      >
        <LinearProgress
          sx={{
            width: '50%', // half of container
            mx: 'auto',
            my: 32,
            backgroundColor: '#ffeae6',
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#f67d69',
            },
          }}
        />
      </Box>
    </FullScreenLayout>
  )
}

/**
 * The page of the tier selection.
 *
 * It currently depends on the type of subsctiption.
 * When only top-up and enterprise subscription are available,
 * the TitleLinearProgress and DefaultSelectTier must be removed.
 */
export const SelectTier = () => {
  const { priceList, companyConsumption } = useSelector(getUserState)

  useEffect(() => {
    // Get prices only once, at the loading of the page
    fetchCompanyConsumption()
    fetchPrice()
  }, [])

  return !companyConsumption?.value?.subscription_tier ? (
    <TitleLinearProgress />
  ) : companyConsumption?.value?.subscription_tier ==
    TierType.TopUpCreditAimd ? (
    <TopUpSelectTier
      subscriptionData={priceList?.value}
      userTier={companyConsumption?.value?.subscription_tier}
    />
  ) : (
    <DefaultSelectTier prices={priceList?.value} />
  )
}
